import type { YaasPositionCardData } from "@solomon-apps/shared/src/types/yaas";
import { BigDecimal } from "@solomon-labs/bigdecimal";

/** Never present a partial portfolio as the complete total while an LP is unresolved. */
export function positionTotal(positions: YaasPositionCardData[]): BigDecimal | null {
    let total = new BigDecimal(0);
    for (const { position } of positions) {
        if (position.usdvAmountExact === null) return null;
        total = total.add(new BigDecimal(position.usdvAmountExact ?? String(position.USDvValue)));
    }
    return total;
}
